// 引流获客
import req from './req'

// 获取渠道码列表
export function getChannelCodeList (params) {
  return req.get('/traffic/dynamic-code/list', params)
}

// 保存渠道活码
export function saveChannelCode (params) {
  return req.post('/traffic/dynamic-code/create', params)
}

// 更新渠道活码
export function updateChannelCode (params) {
  return req.post('/traffic/dynamic-code/update', params)
}

// 获取渠道欢迎语详情
export function getChannelCodeInfo (params) {
  return req.get('/traffic/dynamic-code/info', params)
}

// 获取渠道欢迎语详情
export function getH5Url (params) {
  return req.get('/traffic/wechat-offiaccount/get-url', params)
}

// 获取渠道数据统计
export function getStatistics (params) {
  return req.get('/members/member-todaystat', params)
}

// 渠道-客户统计
export function customerStatistics (params) {
  return req.get('/members/member-statistics', params)
}

// 渠道-统计导出
export function statisticsExport (params) {
  return req.get('/members/member-statistics-export', params)
}

// 渠道-渠道列表
export function getChannelList (params) {
  return req.get('/members/channel-list', params)
}
